var moment = require('moment');
import * as $ from 'jquery';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {UtilityService} from '../shared/services/Utility.service';

@Injectable({
    providedIn: 'root'
})
export class CommonFunction {
    static parameters = [Router, UtilityService]
    constructor(private router: Router, public utilityService: UtilityService) {

    }

    Nevigate_Document_Entry(data) {
        let screenNo = data.ScreenType;
        let TrnasactionNo = data.Transaction_No;
        let Transaction_Date = new Date(data.Transaction_Date);
        Transaction_Date.setHours(0, 0, 0, 0);
        if(this.utilityService.IsbetweenFinDate(Transaction_Date) == false) {
            return false;
        }
        localStorage.setItem('Navigation_Trnasaction_No', TrnasactionNo);

        // 41 - Sales Breakage or Expiry add in sales

        if (screenNo == 16) {  // Sales Invoice
            // this.router.navigate(['sales/salesinvoice/', TrnasactionNo]);
            window.open('sales/salesinvoice');
        } else if (screenNo == 8) {  // Sales Return
            //  this.router.navigate(['sales/salesreturn/', TrnasactionNo]);
            window.open('purchase/purchaseOrder');
        } else if (screenNo == 9) {  // Sales Return
            //  this.router.navigate(['sales/salesreturn/', TrnasactionNo]);
            window.open('sales/salesreturn');
        } else if (screenNo == 6) {  // GRN
            // this.router.navigate(['purchase/goodsReceipt/', TrnasactionNo]);
            window.open('purchase/goodsReceipt');
        } else if (screenNo == 24) {  // SE
            // this.router.navigate(['purchase/selfExpiryAdjustment/', TrnasactionNo]);
            window.open('purchase/selfExpiryAdjustment');
        } else if (screenNo == 25) {  // BD
            // this.router.navigate(['purchase/brekageanddamage/', TrnasactionNo]);
            window.open('purchase/brekageanddamage');
        } else if (screenNo == 15) {  // STKADJ
            // this.router.navigate(['purchase/stockAdjustmentEntry/', TrnasactionNo]);
            window.open('purchase/stockAdjustmentEntry');
        } else if (screenNo == 22) {  // 
            // this.router.navigate(['purchase/godowntransfer/', TrnasactionNo]);
            window.open('purchase/godowntransfer');
        } else if (screenNo == 23) {  // 
            // this.router.navigate(['purchase/batchstocktransfer/', TrnasactionNo]);
            window.open('purchase/batchstocktransfer');
        } else if (screenNo == 19) {  // 
            // this.router.navigate(['purchase/purchaseReturn/', TrnasactionNo]);
            window.open('purchase/purchaseReturn');
        } else if (screenNo == 39) {  // 
            // this.router.navigate(['sales/salesBreakageOrExpiry/', TrnasactionNo]);
            window.open('sales/salesBreakageOrExpiry');
        } else if (screenNo == 43) {  // 
            // this.router.navigate(['sales/salesBreakageOrExpiry/', TrnasactionNo]);
            window.open('purchase/claimManagement');
        }
    }
}